import {
  FETCH_PERMISSION_FAILURE,
  FETCH_PERMISSION_LOADING,
  FETCH_PERMISSION_SUCCESS,
  UPDATE_PERMISSION_FAILURE,
  UPDATE_PERMISSION_LOADING,
  UPDATE_PERMISSION_SUCCESS
} from '../Types/userPermissionsTypes';

const initState = {
  data: [],
  error: null,
  success: null,
  loading: true
};

const permissionReducer = function (state = initState, action) {
  switch (action.type) {
    case FETCH_PERMISSION_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
        data: []
      };
    case FETCH_PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload
      };
    case FETCH_PERMISSION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
        data: []
      };

    case UPDATE_PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'Updated Successfully'
      };
    case UPDATE_PERMISSION_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      };

    case UPDATE_PERMISSION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    default:
      return { ...state };
  }
};

export default permissionReducer;
